import React from "react";
import ReactEcharts from "echarts-for-react";
import { useSelector } from "react-redux";

const AboutPageViews = () => {
  const { aboutPageViews } = useSelector((state) => state?.merchantReducer);
  const totalUsers = aboutPageViews?.data?.total_user; // Total number of users
  const usersVisitedProfile = aboutPageViews?.data?.total_profile_views; // Users who visited the merchant profile
  const usersTappedAboutUs = aboutPageViews?.data?.total_about_us_page; // Users who tapped About Us
  const others = aboutPageViews?.data?.total_user - (aboutPageViews?.data?.total_profile_views + aboutPageViews?.data?.total_about_us_page) //Users who did not done any of the above
  const data = [
    {
      value: usersVisitedProfile,
      name: "Visited Profile",
      itemStyle: {
        color: "#FFC943",
      },
    },
    {
      value: usersTappedAboutUs,
      name: "Tapped About Us",
      itemStyle: {
        color: "#00ADEF",
      },
    },
  ];
  
  if (others > 0) {
    data.push({
      value: others,
      name: "Others",
      itemStyle: {
        color: "#49EA80",
      },
    });
  } else {
    // Add a tiny value to keep the "Others" color in the legend
    data.push({
      value: 0.001,
      name: "Others",
      itemStyle: {
        color: "#49EA80",
      },
    });
  }
  const option = {
    tooltip: {
      trigger: "item",
    },
    legend: {
      bottom: "5%",
      left: "center",
    },
    title: {
      text: `Total Users\n${totalUsers}`,
      left: "center",
      top: "center",
      textStyle: {
        fontSize: 20,
        fontWeight: "bold",
        lineHeight: 30,
      },
    },
    series: [
      {
        name: "User Activity",
        type: "pie",
        radius: ["40%", "70%"],
        avoidLabelOverlap: false,
        label: {
          show: false,
        },
        emphasis: {
          label: {
            show: false,
          },
        },
        labelLine: {
          show: false,
        },
        data
      },
    ],
  };

  return (
    <div className="w-full h-[448px] border border-stroke bg-white py-4 px-5 pt-7.5 pb-5 shadow-default dark:border-strokedark dark:bg-boxdark summary offersChart ">
      <div className="w-full h-full">
        <span className="text-xl font-semibold text-black">About Page Views</span>{" "}
        <ReactEcharts
          option={option}
          style={{ height: "100%", width: "100%", marginTop: "-1.5rem" }}
        />
      </div>
    </div>
  );
};

export default AboutPageViews;
